<template>
  <el-dialog
    class="order-test related-tests-dialog"
    title=""
    :show-close="false"
    modal-class="test-revenue-dialog"
    v-model="isVisible"
    @close="close"
  >
    <template #header>
      <div class="flex justify-between items-center px-6 py-4 bg-[#004879] text-white rounded-t-[10px]">
        <span class="font-semibold text-[20px] leading-normal">Test Revenue - This order only</span>
        <button class="bg-transparent border-none p-0 cursor-pointer w-7 h-7" @click="close">
          <img src="@/assets/MyPatient/close.svg" alt="Close" class="w-full h-full" />
        </button>
      </div>
    </template>
    <div class="mt-4 mx-auto pb-6 dialog-container">
      <Alert :height="34" type="info" class="mb-4">
        <div class="flex items-center pl-3 pt-1">
          <span class="material-icons pr-3 error-icon-size text-lg">error</span>
          <p>{{ $t("OrderPage[\"This will only affect this order, not the default price.\"]") }}</p>
        </div>
      </Alert>
      <SelectedTestsTabPane 
        :item-list="selectedItemList"
        :is-for-markup-dialog="true"
      />
      <div class="flex justify-end mt-6">
        <LoginButton 
          type="primary" 
          class="w-24" 
          @click="close"
          :loading="isLoading"
        >
          {{ $t("OrderPage[\"Close\"]") }}
        </LoginButton>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import SelectedTestsTabPane from "../../../selected-tests-tab-pane/index.vue";
import LoginButton from "@/views/login/components/LoginButton.vue";
import Alert from "../../../../../components/Alert.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SelectedTestsTabPane,
    LoginButton,
    Alert,
  },

  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      isVisible: false,
      isLoading: false
    }
  },

  emits: ["close"],

  computed: {
    ...mapGetters("orderTest", ["selectedItemList"]),
  },

  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },   
  }
}
</script>

<style>
.test-revenue-dialog .el-dialog {
  border-radius: 10px;
  height: auto;
  --el-dialog-padding-primary: 0px !important;
}
.test-revenue-dialog .el-dialog__header {
  padding: 0;
  border-bottom: none;
}
.test-revenue-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.dialog-container {
  width: 568px;
}
.dialog-container :deep(.btn-primary),
.dialog-container :deep(.btn-primary:hover) {
  border-color: #004879 !important;
  background: #004879 !important;
}
</style>